import { z } from "zod";

export const getRoleSchema = z.object({
	roleId: z.uuid(),
});

export type GetRoleSchema = z.infer<typeof getRoleSchema>;
